// export const API_URL = "https://api.getfreadom.com/api/";

// const isProdEnv = () => ['web', 'staging'].includes(window.location?.hostname?.split('.')?.[0]);
const isProdEnv = () => window.location?.hostname?.split(".")?.[0];

export const API_URL =
  isProdEnv() === "web"
    ? "https://api.hello.getfreadom.com/api/"
    : isProdEnv() === "staging"
    ? "https://api.hello.getfreadom.com/api/"
      : "https://api.hello.getfreadom.com/api/";
export const F_LIVE_API_URL =
  isProdEnv() === "web" || isProdEnv() === "staging"
    ? "https://optimus.getfreadom.com/"
    : "https://optimus-alpha.getfreadom.com/";

export const IRO_API_URL = "https://api.iro.getfreadom.com/api/";
